import { Component, OnInit } from '@angular/core';
import { ClientList } from 'src/app/interfaces/landing.interface';
import { LandingService } from 'src/app/services/landing.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  public clientList!: any;
  public loading = false;
  constructor(public landingService: LandingService) {}

  ngOnInit(): void {
    this.loading = true;
    this.landingService.getClientList().subscribe((res) => {
      this.clientList = res;
      this.loading = false;
    });
  }
}
